import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { LangProvider } from "@/lib/i18n";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { PublicLayout } from "@/components/PublicLayout";
import { AdminLayout } from "@/components/AdminLayout";

import Home from "@/pages/public/Home";
import About from "@/pages/public/About";
import ActivityCategory from "@/pages/public/ActivityCategory";
import EventsPage from "@/pages/public/EventsPage";
import SchedulePage from "@/pages/public/SchedulePage";
import NewsPage from "@/pages/public/NewsPage";
import GalleryPage from "@/pages/public/GalleryPage";
import MembershipPage from "@/pages/public/MembershipPage";
import VolunteerPage from "@/pages/public/VolunteerPage";
import DonatePage from "@/pages/public/DonatePage";
import TransparencyPage from "@/pages/public/TransparencyPage";
import ContactPage from "@/pages/public/ContactPage";
import NotFound from "@/pages/public/NotFound";
import VerifyMember from "@/pages/public/VerifyMember";
import PrivacyPolicy from "@/pages/public/PrivacyPolicy";

import AdminLogin from "@/pages/admin/AdminLogin";
import Dashboard from "@/pages/admin/Dashboard";
import MembersAdmin from "@/pages/admin/MembersAdmin";
import EventsAdmin from "@/pages/admin/EventsAdmin";
import SchedulesAdmin from "@/pages/admin/SchedulesAdmin";
import GalleryAdmin from "@/pages/admin/GalleryAdmin";
import NewsAdmin from "@/pages/admin/NewsAdmin";
import BannersAdmin from "@/pages/admin/BannersAdmin";
import ProgramsAdmin from "@/pages/admin/ProgramsAdmin";
import DocumentsAdmin from "@/pages/admin/DocumentsAdmin";
import VolunteersAdmin from "@/pages/admin/VolunteersAdmin";
import EnquiriesAdmin from "@/pages/admin/EnquiriesAdmin";
import DonationsAdmin from "@/pages/admin/DonationsAdmin";
import ContentManager from "@/pages/admin/ContentManager";
import ChangePassword from "@/pages/admin/ChangePassword";
import TrusteesAdmin from "@/pages/admin/TrusteesAdmin";

function App() {
  useEffect(() => { document.title = "Hatha Vidya Charitable Trust"; }, []);
  return (
    <div className="App">
      <AuthProvider>
        <LangProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/programs/:category" element={<ActivityCategory />} />
              <Route path="/events" element={<EventsPage />} />
              <Route path="/schedule" element={<SchedulePage />} />
              <Route path="/news" element={<NewsPage />} />
              <Route path="/gallery" element={<GalleryPage />} />
              <Route path="/membership" element={<MembershipPage />} />
              <Route path="/volunteer" element={<VolunteerPage />} />
              <Route path="/donate" element={<DonatePage />} />
              <Route path="/transparency" element={<TransparencyPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/verify/:code" element={<VerifyMember />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="*" element={<NotFound />} />
            </Route>

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
              <Route index element={<Dashboard />} />
              <Route path="content" element={<ContentManager />} />
              <Route path="banners" element={<BannersAdmin />} />
              <Route path="news" element={<NewsAdmin />} />
              <Route path="programs" element={<ProgramsAdmin />} />
              <Route path="gallery" element={<GalleryAdmin />} />
              <Route path="documents" element={<DocumentsAdmin />} />
              <Route path="events" element={<EventsAdmin />} />
              <Route path="schedules" element={<SchedulesAdmin />} />
              <Route path="trustees" element={<TrusteesAdmin />} />
              <Route path="members" element={<MembersAdmin />} />
              <Route path="volunteers" element={<VolunteersAdmin />} />
              <Route path="enquiries" element={<EnquiriesAdmin />} />
              <Route path="donations" element={<DonationsAdmin />} />
              <Route path="change-password" element={<ChangePassword />} />
            </Route>
          </Routes>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
        </LangProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
